import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AriaPhoneNumberPipe } from './aria-phone-number.pipe';

@NgModule({
  declarations: [AriaPhoneNumberPipe],
  imports: [CommonModule],
  exports: [AriaPhoneNumberPipe],
})
export class AriaPhoneNumberModule {}
